import React, { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import {
  ForgotPasswordModal,
  PForgotPasswordModal,
} from './ForgotPasswordModal';
import { useFetch } from 'src/utils/hooks/useFetch';
import { IForgotPasswordModel } from 'src/api/base/Auth/types';
import { AuthApi } from 'src/api/base/Auth';
import { useResponseFormHandler } from 'src/utils/hooks/useResponseFormHandler';

type TForgotPasswordModalContainer = Pick<
  PForgotPasswordModal,
  'open' | 'onClose' | 'errors'
>;

export const ForgotPasswordModalContainer: React.FC<TForgotPasswordModalContainer> =
  (props) => {
    const { open, onClose } = props;
    const { enqueueSnackbar } = useSnackbar();

    const [{ response, isLoading, error }, fetchForgotPassword] = useFetch<
      any,
      IForgotPasswordModel
    >(AuthApi.forgotPassword);

    useResponseFormHandler({ error });
    useEffect(() => {
      if (response) {
        enqueueSnackbar('Please, check your email', { variant: 'success' });
        // We need small timeout for user
        setTimeout(() => {
          enqueueSnackbar(
            "Didn't get the email? \n" +
              'Please check the spam folder. If that does not help, you can request the email again',
            {
              variant: 'info',
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
              },
            },
          );
        }, 3000);

        onClose();
      }
    }, [response, enqueueSnackbar, onClose]);

    return (
      <ForgotPasswordModal
        onSubmit={fetchForgotPassword}
        loading={isLoading}
        onClose={onClose}
        open={open}
        errors={error}
      />
    );
  };
